import { render, staticRenderFns } from "./ns-icon.vue?vue&type=template&id=5b9c4a5b&scoped=true&"
import script from "./ns-icon.vue?vue&type=script&lang=js&"
export * from "./ns-icon.vue?vue&type=script&lang=js&"
import style0 from "./ns-icon.vue?vue&type=style&index=0&id=5b9c4a5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c4a5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9c4a5b')) {
      api.createRecord('5b9c4a5b', component.options)
    } else {
      api.reload('5b9c4a5b', component.options)
    }
    module.hot.accept("./ns-icon.vue?vue&type=template&id=5b9c4a5b&scoped=true&", function () {
      api.rerender('5b9c4a5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/ns-app-elements/src/ns-icon-vue/ns-icon.vue"
export default component.exports